import { ThemesService } from './ThemesService';

export const themesService = new ThemesService();

export * from './constants';
